import { axiosSwagger } from "@/axios";

export const state = {
  campusAccess: {
    loading: false,
    data: [],
    total: 0,
  },
}


export const getters = {
}


export const mutations = {
  // ACCESS LEVEL
  loading: (state, loading) => {
    state.campusAccess.loading = loading;
  },
  setData: (state, data) => {
    state.campusAccess.data = data;
  },
  setTotal: (state, total) => {
    state.campusAccess.total = total;
  },
  add: (state, data) => {
    state.campusAccess.data.push(data);
  },
  remove: (state, id) => {
    state.campusAccess.data = state.campusAccess.data.filter((el) => el.id !== id);
  },
  // update: (state, data) => {
  //     const index = state.campusAccess.data.findIndex(
  //         (item) => item.id === data.id
  //     );

  //     if (index !== -1) {
  //         state.campusAccess.data[index].applicationUserId = data.applicationUserId;
  //         state.campusAccess.data[index].deliveryUnitIds = data.deliveryUnitIds;
  //     }
  // },
}


export const actions = {
  // ACCESS LEVEL
  async readMyCampusAccess({ commit }) {
    commit("loading", true);

    return await axiosSwagger
    .get("/api/CampusAccess/My")
    .then((response) => {
      commit("setData", response.data);
      commit("setTotal", response.data.length);
      commit("loading", false);

      return response;
    })
    .catch(() => {
      commit("loading", false);
    });
  },
  async createCampusAccess({ commit }, data) {
    return await axiosSwagger
    .post(`/api/CampusAccess/Add`, data)
    .then((response) => {
      commit("add", response.data);

      return response;
    });
  },
  async deleteCampusAccess({ commit }, id) {
    return await axiosSwagger
    .delete(`/api/CampusAccess/Remove/${id}`)
    .then((response) => {
      commit("remove", id);

      return response;
    });
  },
  // async updateCampusAccess({ commit }, data) {
  //     return await axiosSwagger
  //     .put(`/api/CampusAccess/Update/${data.id}/${data.access}`)
  //     .then((response) => {
  //         commit("update", data);

  //         return response;
  //     });
  // },
}
